/* eslint-disable no-console */

/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { KeyboardArrowDown } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
// import DownloadIcon from '@mui/icons-material/Download';
import { Box, Typography, Button, MenuItem, Stack, Paper } from '@mui/material';
import { Loader, MilestoneModel, MultipleMilestoneModel, Toast } from 'app/components';
import { DashedLineChart } from 'app/components/v2';
import { Switch } from 'app/components/v2';
import { IdentityTable } from 'app/components/v2';
import Card from 'app/components/v2/insights/Card';
import { CustomSelect } from './compliance/style';
import {
  getMilestones,
  getStructuredLineData,
  getStructuredPieData,
  getStructuredTableData,
  getUnStructuredLineData,
  getUnStructuredPieData,
  getUnStructuredTableData,
  setChartData,
  setMilestones,
  setPieChartData,
  setStructuredLine,
  setUnstructuredChartData,
  setUnstructuredLine,
  setUnstructuredPieChartData,
} from 'app/store/features/chartsSlice';
import { toggleReset } from 'app/store/features/notificationsSlice';
import { getPolicyById, setChanges } from 'app/store/features/privacyPersistedSlice';
import { deletePolicyByCache, getAllPolicies } from 'app/store/features/privacySlice';
import {
  setAlertOpen,
  setMileStonesDuration,
  setShowMileStone,
} from 'app/store/features/toggleSidebarSlice';
import { ColorsV2 } from 'app/constants/color';
import apiService from 'app/services/apiService';
import {
  arbitraryLinePlugin,
  getMenuItems,
  parseAndFormatDate,
  returnDefaultValues,
} from 'app/utils';
import html2pdf from 'html2pdf.js';
// import Report from './Report';
// import LandscapeReport from './landScapeReport';
import DonutChart from './DonutChart';
import { Buttons, Containers } from 'app/constants/sizing';
import PageTabs from 'app/components/v2/PageTabs/PageTabs';
import { fetchUserSettings } from 'app/store/features/userSettingsSlice';
import { Container } from './style';

export default function Identity() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isStrcuturedTableFetched = useSelector(state => state.charts.isStructuredTableFetched);
  const structuredPie = useSelector(state => state?.charts?.structuredPie);
  const unstructuredPie = useSelector(state => state?.charts?.unstructuredPie);
  const structuredLine = useSelector(state => state.charts.structuredLine);
  const unStructureLine = useSelector(state => state.charts.unstructuredLine);
  const structuredTable = useSelector(state => state.charts.structuredTable);
  const unStructuredTable = useSelector(state => state.charts.unstructuredTable);
  const isUnStructuredTableFetched = useSelector(state => state.charts.isUnStructuredTableFetched);
  const isMilestonesFetched = useSelector(state => state.charts.isMilestonesFetched);
  const pieChart = useSelector(state => state.charts.chartData);
  const milestoneData = useSelector(state => state.charts.milestones);
  const unstructuredPieChart = useSelector(state => state.charts.unstructuredChartData);
  const isStructuredLineFetched = useSelector(state => state.charts.isStructuredLineFetched);
  const isUnStructuredLineFetched = useSelector(state => state.charts.isUnStructuredLineFetched);
  const isStructuredPieFetched = useSelector(state => state.charts.isStructuredPieFetched);
  const isUnStructuredPieFetched = useSelector(state => state.charts.isUnStructuredPieFetched);

  const allPolicies = useSelector(state => state.privacy.allPolicies);
  const showMileStone = useSelector(state => state.toggleSidebar.showMileStone);
  const mileStonesDuration = useSelector(state => state.toggleSidebar.mileStonesDuration);
  const { createdPolicy, changes } = useSelector(state => state.privacyPersisted);

  const [lineData, setLineData] = useState([]);
  const [dates, setDates] = useState({ startDate: '', endDate: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [UnstructuredLineData, setUnstructuredLineData] = useState([]);
  const [isLandScape, setIsLandScape] = useState(false);
  const [clicked, setClicked] = useState([]);
  const [USclicked, setUSClicked] = useState([]);
  const [reportModel, setReportModel] = useState(false);
  const [value, setValue] = useState(0);
  const [isMilestoneModelOpen, setIsMilestoneModelOpen] = useState(false);
  const [isMultipleMilestoneModelOpen, setIsMultipleMilestoneModelOpen] = useState(false);
  const [currentMilestoneData, setCurrentMilestoneData] = useState([]);
  const [unCurrentMilestoneData, setUnCurrentMilestoneData] = useState([]);
  const [fetchedMultipleMilestoneData, setFetchedMultipleMilestoneData] = useState([]);
  const [multipleMilestoneData, setMultipleMilestoneData] = useState([]);
  const [generatedMilestones, setGeneratedMilestones] = useState({});

  const arrays = lineData?.map(item => item.dataPoints);
  const labels =
    arrays?.length > 0
      ? arrays[0]?.map(dataPoint => {
          const date = new Date(dataPoint.date);
          const formattedDate = parseAndFormatDate(date);
          return formattedDate;
        })
      : [new Date()];
  const latestDate = new Date(
    Math.max.apply(
      null,
      labels?.map(date => new Date(date))
    )
  );
  const threeMonthsAgo = new Date(latestDate);
  threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);

  const extractedProducts = [];
  const extractedUnstructuredProducts = [];

  const generateKey = (productName, productId) => `${productName}-${productId}`;
  for (const categoryObj of structuredTable || []) {
    const products = categoryObj.dataClassLevels;

    for (const productObj of products) {
      const productName = productObj.name;
      const productId = productObj.id;
      const key = generateKey(productName, productId);

      if (!extractedProducts.some(obj => generateKey(obj.productName, obj.productId) === key)) {
        extractedProducts.push({ productName, productId });
      }
    }
  }

  for (const categoryObj of unStructuredTable || []) {
    const products = categoryObj.dataClassLevels;

    for (const productObj of products) {
      const productName = productObj.name;
      const productId = productObj.id;
      const key = generateKey(productName, productId);

      if (
        !extractedUnstructuredProducts.some(
          obj => generateKey(obj.productName, obj.productId) === key
        )
      ) {
        extractedUnstructuredProducts.push({ productName, productId });
      }
    }
  }

  useEffect(() => {
    if (extractedProducts?.length > 3 || extractedUnstructuredProducts?.length > 3) {
      // setIsLandScape(true); - Landscape report is currently not functional, defaulting to normal report in all instances
      setIsLandScape(false);
    } else {
      setIsLandScape(false);
    }
  }, [structuredTable, unStructuredTable]);

  useEffect(() => {
    const formattedData = milestoneData?.map(obj => ({
      ...obj,
      date: parseAndFormatDate(obj.date),
      pointY: 30,
    }));
    setGeneratedMilestones({...arbitraryLinePlugin(formattedData, setFetchedMultipleMilestoneData, 'v2') || {}});
  }, [milestoneData, arbitraryLinePlugin]);

  const UnstructuredLineDataarrays = UnstructuredLineData?.map(item => item.dataPoints);
  const UnstructuredLineDataarrayslabels =
    UnstructuredLineDataarrays?.length > 0
      ? UnstructuredLineDataarrays[0]?.map(dataPoint => {
          const date = new Date(dataPoint.date);
          const formattedDate = parseAndFormatDate(date);
          return formattedDate;
        })
      : [];

  const { t } = useTranslation('translation', { keyPrefix: 'identify_headings' });

  const UnstructuredLineDatalatestDate = new Date(
    Math.max.apply(
      null,
      UnstructuredLineDataarrayslabels?.map(date => new Date(date))
    )
  );

  const UnstructuredLineDatathreeMonthsAgo = new Date(UnstructuredLineDatalatestDate);
  UnstructuredLineDatathreeMonthsAgo.setMonth(UnstructuredLineDatathreeMonthsAgo.getMonth() - 3);

  const handleChange = (_, value) => {
    setValue(value);
    setClicked([]);
    setUSClicked([]);
  };

  const onButtonClick = () => {
    setReportModel(true);
    const element = document.getElementById('content');
    const opt = {
      margin: 0,
      filename: 'document.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { format: 'a3', orientation: 'portrait' },
    };

    html2pdf().set(opt).from(element).save();
  };

  const fetchChartsData = useCallback(() => {
    if (!isStrcuturedTableFetched) {
      dispatch(getStructuredTableData());
    }
    if (!isUnStructuredTableFetched) {
      dispatch(getUnStructuredTableData());
    }
    if (!isStructuredLineFetched) {
      dispatch(getStructuredLineData());
    }
    if (!isUnStructuredLineFetched) {
      dispatch(getUnStructuredLineData());
    }
    if (!isStructuredPieFetched) {
      dispatch(getStructuredPieData());
    }
    if (!isUnStructuredPieFetched) {
      dispatch(getUnStructuredPieData());
    }
    if (!isMilestonesFetched) {
      dispatch(getMilestones());
    }
  }, []);

  const fetchMilestones = async () => {
    try {
      setIsLoading(true);
      const { milestones } = await apiService.getMilestones();
      dispatch(setMilestones(milestones));
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setError(error);
    }
  };
  useEffect(() => {
    fetchChartsData();
  }, [fetchChartsData]);

  useEffect(() => {
    dispatch(fetchUserSettings());
  }, [])

  useEffect(() => {
    dispatch(toggleReset());
    dispatch(setChanges(false));
    dispatch(setAlertOpen(false));
    dispatch(getAllPolicies());
    if (createdPolicy?.policyType && changes) {
      dispatch(deletePolicyByCache(createdPolicy?.policyType));
    }
  }, []);

  useEffect(() => {
    const filtered = milestoneData?.filter(obj => {
      const objDate = new Date(obj.date);
      return objDate >= threeMonthsAgo && objDate <= latestDate;
    });
    setCurrentMilestoneData(filtered);
    const filtered2 = milestoneData?.filter(obj => {
      const objDate = new Date(obj.date);
      return (
        objDate >= UnstructuredLineDatathreeMonthsAgo && objDate <= UnstructuredLineDatalatestDate
      );
    });
    setUnCurrentMilestoneData(filtered2);
  }, [milestoneData]);

  useEffect(() => {
    dispatch(toggleReset());
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    if (error) {
      setIsLoading(false);
      console.error(error);
    }
  }, [error]);

  useEffect(() => {
    const fetchPieData = async () => {
      try {
        setIsLoading(true);

        const response = await apiService.structuredChartData('/structured');
        dispatch(setChartData(response?.data?.structured));
        dispatch(setPieChartData(response?.data?.structured?.dataClassLevelSpread));
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setError(error);
      }
    };
    fetchPieData();
    const fetchUnstructuredPieData = async () => {
      try {
        setIsLoading(true);

        const response = await apiService.structuredChartData('/unstructured');
        dispatch(setUnstructuredChartData(response?.data?.unstructured));
        dispatch(setUnstructuredPieChartData(response?.data?.unstructured?.dataClassLevelSpread));
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setError(error);
      }
    };
    fetchUnstructuredPieData();
    const fetchLineData = async () => {
      try {
        setIsLoading(true);

        const response = await apiService.lineChartData('/structured');
        setLineData(response.data.structured);
        setDates({
          startDate: response.data.startDate,
          endDate: response.data.endDate,
        });
        dispatch(setStructuredLine(response.data.structured));
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setError(error);
      }
    };
    fetchLineData();
    const fetchULineData = async () => {
      try {
        setIsLoading(true);

        const response = await apiService.lineChartData('/unstructured');
        setUnstructuredLineData(response.data.unstructured);
        setDates({
          startDate: response.data.startDate,
          endDate: response.data.endDate,
        });
        dispatch(setUnstructuredLine(response.data.unstructured));
        setIsLoading(false);
      } catch (error) {
        setError(error);

        console.error(error);
      }
    };
    fetchULineData();
  }, []);

  useEffect(() => {
    if (!fetchedMultipleMilestoneData.length) {
      setIsMultipleMilestoneModelOpen(false);
      setIsMilestoneModelOpen(false);
    } else if (fetchedMultipleMilestoneData.length > 1) {
      setIsMultipleMilestoneModelOpen(true);
    } else {
      setIsMilestoneModelOpen(true);
    }
  }, [fetchedMultipleMilestoneData]);

  const handleView = () => {
    dispatch(getPolicyById({ id: allPolicies.policyType, readOnly: true })).then(res => {
      if (!res.error) {
        if (allPolicies.templateId) {
          navigate('/board/template', { state: { action: 'VIEW' } });
        } else {
          navigate('/board/blank', { state: { action: 'VIEW' } });
        }
      }
    });
  };

  const handleMileStoneToggle = () => {
    dispatch(setShowMileStone({ ...showMileStone, insights: !showMileStone.insights }));
  };


  if (isLoading) {
    return <Loader color={ColorsV2.acent} />;
  }
  return (
      <Container
        sx={{
          paddingY: '20px',
          backgroundColor: ColorsV2.secondary,
        }}
      >
        <Box paddingX={4} color={ColorsV2.white}>
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            borderBottom={`2px solid ${ColorsV2.outline}`}
            paddingBottom={1}
          >
            <Typography variant='h4'>
              {t('main_heading')}
            </Typography>
            {/* {structuredPie?.length ||
            unstructuredPie?.length ||
            structuredLine?.length ||
            unStructureLine?.length ||
            structuredTable?.length ||
            unStructuredTable?.length ? (
              <></>
            ) : (
              // <StyledButton
              //   sx={{
              //     color: ColorsV2.white,
              //     textTransform: 'uppercase',
              //     background: 'transparent',
              //     borderRadius: '5px',
              //     border: `1px solid ${ColorsV2.white}`,
              //   }}
              //   name={'IconButton'}
              //   onClick={onButtonClick}
              //   startIcon={<DownloadIcon style={{ fontSize: '0.9em', color: ColorsV2.white }} />}
              // >
              //   pdf
              // </StyledButton>
              ''
            )} */}
          </Box>
          <Box borderBottom={`2px solid ${ColorsV2.outline}`} paddingBottom={1}>
            <Typography variant='body1' color={ColorsV2.textInfo} marginY={2}>
              {t('description')}{' '}
            </Typography>
            <Typography variant='body1' color={ColorsV2.textInfo} marginY={2}>
              {t('description_2')}
            </Typography>
          </Box>
            <Box sx={{marginTop: '20px'}}>
              <PageTabs
              value={value}
              onChange={handleChange}
              tabs={[
                {value: 0, label: t('StructuredDataSource'), props: {sx: {backgroundColor: ColorsV2.secondary, "&.Mui-selected": {backgroundColor: ColorsV2.primary}}}},
                {value: 1, label: t('UnstructuredDataSource'), props: {sx: {backgroundColor: ColorsV2.secondary, "&.Mui-selected": {backgroundColor: ColorsV2.primary}}}}
                ]} />
            </Box>
          <Stack direction='column' sx={{backgroundColor: ColorsV2.primary, padding: '20px'}}>
            <Stack direction='row' alignItems='center' justifyContent='space-between'>
              <Paper sx={{
                ...Containers.shadowSubtleAcent,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 3,
                backgroundColor: ColorsV2.primary,
                margin: '20px',
                marginLeft: 0,
                width: 'max-content',
              }}>
                <Card
                  title={t('datasource_connected')}
                  data={(pieChart?.datasources?.length || 0) + (unstructuredPieChart?.datasources?.length || 0)}
                />
                <Card
                  title={t('datasource_scanning')}
                  data={
                    value ? (unstructuredPieChart?.datasources?.length || 0) : (pieChart?.datasources?.length || 0)
                  }
                />
                <Card
                  title={t('objects_found')}
                  data={value ? (unstructuredPieChart.nrOfScannedObjects || 0) : (pieChart.nrOfScannedObjects || 0)}
                />
              </Paper>
              <Paper
                sx={{
                  ...Containers.shadowSubtleAcent,
                  marginY: '20px',
                  height: '100%',
                  backgroundColor: ColorsV2.primary,
                }}
              >
                  <Typography borderBottom={`2px solid ${ColorsV2.outline}`} color={ColorsV2.textInfo} variant='subtitle2'>
                    {t('sub_heading')}
                  </Typography>
                  <Typography py={1} variant='subtitle2' color={ColorsV2.white}>
                    {allPolicies?.name} {parseAndFormatDate(allPolicies?.created)}
                  </Typography>
                  <Button
                    variant='text'
                    onClick={handleView}
                    sx={{
                      p: 0,
                      ...Buttons.baseStyle.textButton,
                    }}
                  >
                    <Typography variant='subtitle2' color={ColorsV2.acent}>{t('view_details')}</Typography>
                  </Button>
              </Paper>
            </Stack>
            <Stack direction={'row'} justifyContent={'space-between'} gap={3}>
              <Paper direction='column' alignItems='center' 
              sx={{
                ...Containers.shadowSubtleAcent,
                backgroundColor: ColorsV2.primary,
                width: '350px',
                height: 'fit-content',
              }}>
                  <Typography variant={'h5'} sx={{color: ColorsV2.white, textAlign: 'center'}}>
                    {t('breakdown')}
                  </Typography>
                  <DonutChart
                    setClicked={value ? setUSClicked : setClicked}
                    clicked={value ? USclicked : clicked}
                    title={value ? 'unstructured' : 'structured'}
                    type='identify'
                    chartData={(value ? unstructuredPie : structuredPie) || []}
                    // totalNrOfObjects={value ? unstructuredPieChart.nrOfScannedObjects : pieChart.nrOfScannedObjects}
                  ></DonutChart>
                  <Typography variant={'body1'} sx={{color: ColorsV2.textInfo}}>
                    {t('description_sub')}
                  </Typography>
              </Paper>
              <Paper
              sx={{
                ...Containers.shadowSubtleAcent,
                flexDirection: 'column',
                justifyContent: 'flex-start',
                backgroundColor: ColorsV2.primary,
                minWidth: '500px',
                width: '100%',
              }}>
                  <Stack direction='column' alignItems={'flex-start'} gap={2} sx={{marginLeft: '10px',}}>
                    <Typography variant='h5' color={ColorsV2.white}>
                      {t('progress_time')}
                    </Typography>
                    <Stack direction='row' alignItems={'center'} gap={2}>
                      <Stack direction='row' alignItems='center' gap={1} sx={{ backgroundColor: ColorsV2.primary }}>
                        <Typography color={ColorsV2.textInfo} variant='body1'>
                          {t('milestones')}
                        </Typography>
                        <Switch checked={showMileStone.insights} handlechange={handleMileStoneToggle} />
                      </Stack>
                      <Stack direction='row' alignItems='center' gap={1} sx={{ backgroundColor: ColorsV2.primary }}>
                        <Typography color={ColorsV2.textInfo} variant='body1'>
                          {t('period')}
                        </Typography>
                        <CustomSelect
                          defaultValue={returnDefaultValues(
                            new Date(),
                            value ? new Date(labels[0]) : new Date(UnstructuredLineDataarrayslabels[0])
                          )}
                          value={mileStonesDuration.insights}
                          onChange={e =>
                            dispatch(
                              setMileStonesDuration({ ...mileStonesDuration, insights: e.target.value })
                            )
                          }
                          IconComponent={KeyboardArrowDown}
                          sx={{
                            width: 'max-content',
                          }}
                          inputProps={{
                            'aria-label': 'Language Selector',
                            MenuProps: {
                              PaperProps: {
                                sx: {
                                  backgroundColor: ColorsV2.secondary,
                                  color: ColorsV2.white,
                                  border: `2px solid ${ColorsV2.outline} `,
                                },
                              },
                            },
                          }}
                        >
                          {getMenuItems(
                            new Date(),
                            value ? new Date(labels[0]) : new Date(UnstructuredLineDataarrayslabels[0])
                          ).map(item => (
                            <MenuItem key={item.label} value={item.value} fontSize={'0.7em'}>
                              {item.label}
                            </MenuItem>
                          ))}
                        </CustomSelect>
                      </Stack>
                      <Button
                        name='IconButton'
                        onClick={() => setIsMilestoneModelOpen(true)}
                        startIcon={<AddIcon style={{ color: ColorsV2.white, fontSize: '0.8rem' }} />}
                        sx={{
                          ...Buttons.baseStyle.primaryButtonLowPriority,
                          height: '30px',
                          fontSize: '0.8rem',
                          boxShadow: 0,
                        }}
                      >
                        {t('AddMilestone')}
                      </Button>
                    </Stack>
                  </Stack>
                  {unStructureLine && structuredLine && <DashedLineChart
                    clicked={value ? USclicked : clicked}
                    setClicked={value ? setUSClicked : setClicked}
                    chartData={value ? unStructureLine : structuredLine}
                    MileStones={showMileStone.insights ? generatedMilestones : {}}
                    time={mileStonesDuration.insights}
                    dates={dates}
                  />}
                </Paper>
            </Stack>
          {/* Component for display data sources and details report */}
          {unStructuredTable && structuredTable && (
            <Paper
              sx={{
                ...Containers.shadowSubtleAcent,
                flexDirection: 'column',
                justifyContent: 'flex-start',
                backgroundColor: ColorsV2.primary,
                height: 'max-content',
                marginY: '20px',
              }}
            >
              <Box py={3}>
                <Typography variant='h5' color={ColorsV2.white}>
                  {t('datasource_details')}
                </Typography>
                <Typography variant={'body1'} color={ColorsV2.textInfo}>{t('description_sub_2')}</Typography>
              </Box>
              <IdentityTable
                data={value ? unStructuredTable : structuredTable}
                setIsLandScape={setIsLandScape}
                key={value}
              />
            </Paper>
          )}
            
          </Stack>
        </Box>

        {isMilestoneModelOpen && (
          <MilestoneModel
            setIsMilestoneModelOpen={setIsMilestoneModelOpen}
            setFetchedMultipleMilestoneData={setFetchedMultipleMilestoneData}
            fetchedMultipleMilestoneData={fetchedMultipleMilestoneData}
            multipleMilestoneData={multipleMilestoneData}
            setMultipleMilestoneData={setMultipleMilestoneData}
          />
        )}
        {isMultipleMilestoneModelOpen && (
          <MultipleMilestoneModel
            fetchedMultipleMilestoneData={fetchedMultipleMilestoneData}
            fetchMilestones={fetchMilestones}
            setIsMilestoneModelOpen={setIsMilestoneModelOpen}
            setFetchedMultipleMilestoneData={setFetchedMultipleMilestoneData}
            setIsMultipleMilestoneModelOpen={setIsMultipleMilestoneModelOpen}
            setMultipleMilestoneData={setMultipleMilestoneData}
          />
        )}
        {/* {reportModel && (
          <Box
            sx={{
              height: '100vh',
              backgroundColor: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Modal
              open={reportModel}
              sx={{
                height: '100vh',
                overflow: 'scroll',
              }}
            >
              {isLandScape ? (
                <LandscapeReport
                  setReportModel={setReportModel}
                  latestDate={latestDate}
                  threeMonthsAgo={threeMonthsAgo}
                  UnstructuredLineDatalatestDate={UnstructuredLineDatalatestDate}
                  UnstructuredLineDatathreeMonthsAgo={UnstructuredLineDatathreeMonthsAgo}
                  currentMilestoneData={currentMilestoneData}
                  unCurrentMilestoneData={unCurrentMilestoneData}
                />
              ) : (
                <Report
                  setReportModel={setReportModel}
                  latestDate={latestDate}
                  threeMonthsAgo={threeMonthsAgo}
                  UnstructuredLineDatalatestDate={UnstructuredLineDatalatestDate}
                  UnstructuredLineDatathreeMonthsAgo={UnstructuredLineDatathreeMonthsAgo}
                  currentMilestoneData={currentMilestoneData}
                  unCurrentMilestoneData={unCurrentMilestoneData}
                />
              )}
            </Modal>
          </Box>
        )} */}
      </Container>
  );
}
